import { Badges } from "../../AbstractElements";
import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";

const ActivityActionBadge = ({ action }: { action: string }) => (
  <Badges
    color="transparent"
    className={`badge-light-${
      action === "Deleted"
        ? "danger"
        : action === "Password Changed"
        ? "warning"
        : action === "Edited"
        ? "info"
        : "success"
    }`}
  >
    {action}
  </Badges>
);


export const ActivityHistoryColumns = (t: TFunction): TableColumn<any>[] => [
  {
    name: t("Date"),
    selector: (row) => row.date,
    sortable: true,
  },

  {
    name: t("SectionUpdate"),
    selector: (row) => row.details,
    sortable: false,
    grow: 3,
  },
  {
    name: t("Action"),
    cell: (row) => <ActivityActionBadge action={row.action} />,
    sortable: true,
  },
];


